<template>
  <div id="app">
    <Carrito />
    <div class="overlay-micarrito"></div>

    <header-partial v-if="showHeader" />
    <header-checkout-partial v-if="showHeaderCheckout" />

    <router-view :key="$route.fullPath" />

    <footer-partial v-if="showFooter" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderPartial from "@/components/HeaderPartial";
import HeaderCheckoutPartial from "@/components/HeaderCheckoutPartial";
import FooterPartial from "@/components/FooterPartial";
import Carrito from "@/components/Carrito";
import Api from '@/Api'

// Routes that should not show header
const NO_HEADER_ROUTES = [
  '/login',
  '/register',
  '/forgot',
  '/cart',
  '/shipment',
  '/payment',
  '/success/transferencia-bancaria'
];

// Routes that should show checkout header
const CHECKOUT_HEADER_ROUTES = [
  '/cart',
  '/shipment',
  '/payment',
  '/success/transferencia-bancaria'
];

export default {
  name: 'App',
  components: {
    Carrito,
    FooterPartial,
    HeaderPartial,
    HeaderCheckoutPartial
  },

  computed: {
    ...mapGetters(['user', 'isLogged']),

    showHeader() {
      return !NO_HEADER_ROUTES.includes(this.$route.path);
    },

    showHeaderCheckout() {
      return CHECKOUT_HEADER_ROUTES.includes(this.$route.path);
    },

    showFooter() {
      return this.$route.path !== '/login';
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  async mounted() {
    await this.initializeApp();
  },

  methods: {
    async initializeApp() {
      if (!localStorage.rogg_token) return;

      try {
        this.isLoading = true;

        //Load Configuration
        Api().get('config')
          .then(({ data }) => {
            console.log(data);
            this.$store.dispatch('setConfiguration', data);
          }).catch((err) => {
          console.error(err);
        });

        await this.$store.dispatch('getUser', this);
        await this.loadCart();
      } catch (error) {
        console.error('Error initializing app:', error);
        await this.handleInitializationError();
      } finally {
        this.isLoading = false;
      }
    },

    async loadCart() {
      try {
        await this.$store.dispatch('loadCartFromStorage', {});
        // Get new prices for products logic can be added here
      } catch (error) {
        console.error('Error loading cart:', error);
        throw error;
      }
    },

    async handleInitializationError() {
      await this.$store.dispatch('cleanCart');
      await this.$store.dispatch('logout');
      try {
        await this.$router.push({ name: 'Login' });
      } catch (routerError) {
        console.error('Error redirecting to login:', routerError);
      }
    }
  }
};
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.overlay-micarrito {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100000;
  display: none;
}

.overlay-micarrito.active {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue